import Vue from 'vue'

Vue.filter('carSelexy', (title: string | null): string => {
  if (!title) return ''
  return title.replace('CarSelexy', '')
})
